class DsAccordion {
    constructor(container) {
        this.accordionContainer = container;
        if (!this.accordionContainer) return;

        this.accordionItems = this.accordionContainer.querySelectorAll('.ds-accordion');
        if (!this.accordionItems.length) return;

        this.sectionId = this.accordionContainer.dataset.accordionContainer;

        this.init();
    }

    init() {
        this.setupAccordions();

        // Setup initial state - only expand items that have 'active' class
        this.accordionItems.forEach((item) => {
            if (item.dataset.drawer === 'true') return;
            const content = item.querySelector('.ds-accordion-content');
            if (content) {
                if (item.classList.contains('active')) {
                    content.style.height = `${content.scrollHeight}px`;
                } else {
                    content.style.height = '0';
                }
            }
        });
    }

    setupAccordions() {
        this.accordionItems.forEach((item) => {
            if (item.dataset.drawer === 'true') return;

            const heading = item.querySelector('.ds-accordion-heading');
            const button = heading.querySelector('.ds-accordion-button');

            heading.addEventListener('click', () => {
                this.toggleAccordion(item);
            });

            const content = item.querySelector('.ds-accordion-content');

            // Set initial height for all contents
            content.style.height = item.classList.contains('active') ? `${content.scrollHeight}px` : '0';
            content.style.overflow = 'hidden';
            content.style.transition = 'height 0.3s ease';
        });
    }

    toggleAccordion(item) {
        const isOpen = item.classList.contains('active');
        const button = item.querySelector('.ds-accordion-button');
        const content = item.querySelector('.ds-accordion-content');

        // First, close all accordions and set their heights to 0
        this.accordionItems.forEach(otherItem => {
            if (otherItem !== item) {
                otherItem.classList.remove('active');
                otherItem.querySelector('.ds-accordion-button').setAttribute('aria-expanded', 'false');
                const otherContent = otherItem.querySelector('.ds-accordion-content');
                otherContent.style.height = '0';
                otherContent.setAttribute('aria-hidden', 'true');
            }
        });

        // If the clicked item was not already open, open it
        if (!isOpen) {
            item.classList.add('active');
            button.setAttribute('aria-expanded', 'true');
            content.setAttribute('aria-hidden', 'false');
            content.style.height = `${content.scrollHeight}px`;
        } else {
            item.classList.remove('active');
            button.setAttribute('aria-expanded', 'false');
            content.style.height = '0';
            content.setAttribute('aria-hidden', 'true');
        }
    }
}

// Initialize accordions when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    const accordionContainers = document.querySelectorAll('[data-accordion-container]');
    accordionContainers.forEach(container => {
        new DsAccordion(container);
    });
});

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const accordionContainer = event.target.querySelector('[data-accordion-container]');
        if (accordionContainer) {
            new DsAccordion(accordionContainer);
        }
    });

    document.addEventListener('shopify:section:reorder', () => {
        const accordionContainers = document.querySelectorAll('[data-accordion-container]');
        accordionContainers.forEach(container => {
            new DsAccordion(container);
        });
    });
}
